(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('PendingAssignmentRateReportController', PendingAssignmentRateReportController);

    PendingAssignmentRateReportController.$inject = [
        '$scope', '$http', '$timeout', '$q', 'moment', 'AlertService', 'paginationConstants', 'initialFrom', 'initialTo', '$filter',
        '$state', '$window'
    ];

    function PendingAssignmentRateReportController(
        $scope, $http, $timeout, $q, moment, AlertService, paginationConstants, initialFrom, initialTo, $filter,
        $state, $window
    ) {
        var translate = $filter('translate');
        var vm = this;

        vm.fromDate = initialFrom;
        vm.toDate = initialTo;
        vm.granularity = 'WEEKLY';
        vm.appraisalType = '';
        vm.orderTypeValues = [
            'RESIDENTIAL_FULL_REPORT',
            'RESIDENTIAL_LAND_APPRAISAL',
            'RESIDENTIAL_MULTI_RESIDENT',
            'AVM_BASIC',
            'AVM',
            'AVM_COMPARABLES',
            'DRIVEBY',
            'DESKTOP',
            'RESIDENTIAL_INSPECTION_REPORTS',
            'STANDALONE_MARKET_RENT',
            'STANDALONE_MARKET_RENT_NO_VISIT',
            'STANDALONE_MARKET_RENT_NEW_BUILD',
            'STANDALONE_MARKET_RENT_NEW_BUILD_NO_VISIT',
            'MARKET_RENT_CONSULTING',
            'AUTOMATED_MARKET_RENT_REPORT',
            'RESIDENTIAL_NARRATIVE',
            'COMMERCIAL_NARRATIVE',
            'GENERAL_NARRATIVE',
            'RELOCATION'
        ];
        vm.loading = false;
        vm.chartLoading = false;
        vm.tableLoading = false;
        vm.regionTableLoading = false;
        vm.cityTableLoading = false;
        vm.lenderTableLoading = false;
        vm.series = null;
        vm.chart = null;

        vm.summary = null;
        vm.orders = [];
        vm.ordersTotalElements = 0;
        vm.ordersPage = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.regionRows = [];
        vm.regionTotalElements = 0;
        vm.regionPage = 1;
        vm.regionPredicate = 'entries';
        vm.regionAscending = false;

        vm.cityRows = [];
        vm.cityTotalElements = 0;
        vm.cityPage = 1;
        vm.cityPredicate = 'entries';
        vm.cityAscending = false;

        vm.lenderRows = [];
        vm.lenderTotalElements = 0;
        vm.lenderPage = 1;
        vm.lenderPredicate = 'entries';
        vm.lenderAscending = false;

        vm.lenderFilterRegion = null;
        vm.lenderFilterRegionSearch = '';
        vm.lenderFilterCity = null;
        vm.lenderFilterCitySearch = '';

        vm.lenderDrilldownOptions = [];
        vm.selectedLenderIds = [];
        vm.lenderOptionsLoading = false;

        vm.earliestReportDate = moment('2026-01-01').startOf('day').toDate(); // matches EARLIEST_ALLOWED_FROM_DATE and the pending_assignment_event backfill floor
        vm.latestReportDate = moment().endOf('day').toDate();

        vm.load = load;
        vm.loadTimeSeriesOnly = loadTimeSeriesOnly;
        vm.applyYearToDate = applyYearToDate;
        vm.clearReportFilters = clearReportFilters;
        vm.onOrdersPageChange = onOrdersPageChange;
        vm.onRegionPageChange = onRegionPageChange;
        vm.onCityPageChange = onCityPageChange;
        vm.onLenderPageChange = onLenderPageChange;
        vm.onRegionSortCallback = onRegionSortCallback;
        vm.onCitySortCallback = onCitySortCallback;
        vm.onLenderSortCallback = onLenderSortCallback;
        vm.openOrderInNewTab = openOrderInNewTab;
        vm.queryRegionsForLenderFilter = queryRegionsForLenderFilter;
        vm.queryCitiesForLenderFilter = queryCitiesForLenderFilter;
        vm.onLenderFilterRegionSelected = onLenderFilterRegionSelected;
        vm.onLenderFilterCitySelected = onLenderFilterCitySelected;
        load();

        $scope.$on('$destroy', function() {
            destroyChart();
        });

        function destroyChart() {
            if (vm.chart) {
                vm.chart.destroy();
                vm.chart = null;
            }
        }

        function applyYearToDate() {
            var yearStart = moment().startOf('year');
            var floor = moment(vm.earliestReportDate);
            vm.fromDate = (yearStart.isBefore(floor) ? floor : yearStart).toDate();
            vm.toDate = moment().endOf('day').toDate();
            load();
        }

        function clearReportFilters() {
            vm.lenderFilterRegion = null;
            vm.lenderFilterRegionSearch = '';
            vm.lenderFilterCity = null;
            vm.lenderFilterCitySearch = '';
            vm.selectedLenderIds = [];
        }

        function getRangeParams() {
            var fromM = moment(vm.fromDate).startOf('day');
            var floor = moment(vm.earliestReportDate);
            if (fromM.isBefore(floor)) {
                fromM = floor;
                vm.fromDate = fromM.toDate();
            }
            return {
                from: fromM.format(),
                to: moment(vm.toDate).endOf('day').format()
            };
        }

        function getFilterParams() {
            var p = getRangeParams();
            if (vm.appraisalType) {
                p.appraisalType = vm.appraisalType;
            }
            return p;
        }

        function getFilterParamsKey() {
            var p = getFilterParams();
            return p.from + '|' + p.to + '|' + (p.appraisalType || '');
        }

        function getLenderOptionsKey() {
            return getFilterParamsKey() + '|' +
                (vm.lenderFilterRegion && vm.lenderFilterRegion.id != null ? String(vm.lenderFilterRegion.id) : '') + '|' +
                (vm.lenderFilterCity && vm.lenderFilterCity.id != null ? String(vm.lenderFilterCity.id) : '');
        }

        function getRegionCityBreakdownKey() {
            var sortedIds = (vm.selectedLenderIds || []).slice().sort(function(a, b) { return a - b; });
            return getFilterParamsKey() + '|' + sortedIds.join(',');
        }

        function lenderIdsOnlyParams() {
            var p = {};
            if (vm.selectedLenderIds && vm.selectedLenderIds.length) {
                p.lenderIds = vm.selectedLenderIds;
            }
            return p;
        }

        function regionBreakdownParams(page) {
            return angular.extend({
                page: page - 1,
                size: vm.itemsPerPage,
                sortColumn: vm.regionPredicate,
                sortAscending: vm.regionAscending
            }, getFilterParams(), lenderIdsOnlyParams());
        }

        function cityBreakdownParams(page) {
            return angular.extend({
                page: page - 1,
                size: vm.itemsPerPage,
                sortColumn: vm.cityPredicate,
                sortAscending: vm.cityAscending
            }, getFilterParams(), lenderIdsOnlyParams());
        }

        function lenderGeoParams() {
            var p = {};
            if (vm.lenderFilterRegion && vm.lenderFilterRegion.id) {
                p.regionId = vm.lenderFilterRegion.id;
            }
            if (vm.lenderFilterCity && vm.lenderFilterCity.id) {
                p.cityId = vm.lenderFilterCity.id;
            }
            return p;
        }

        function lenderBreakdownParams(page) {
            return angular.extend({
                page: page - 1,
                size: vm.itemsPerPage,
                sortColumn: vm.lenderPredicate,
                sortAscending: vm.lenderAscending
            }, getFilterParams(), lenderGeoParams());
        }

        function chartAndOrdersParams() {
            var p = angular.extend({}, getFilterParams(), lenderGeoParams());
            if (vm.selectedLenderIds && vm.selectedLenderIds.length) {
                p.lenderIds = vm.selectedLenderIds;
            }
            return p;
        }

        function lenderOptionsRequestParams() {
            return angular.extend({}, getFilterParams(), lenderGeoParams());
        }

        function queryRegionsForLenderFilter(searchText) {
            return $http.get('api/regions', {
                params: { query: searchText || '', size: 50, page: 0, sort: 'name,asc' }
            }).then(function(response) {
                return response.data || [];
            });
        }

        function queryCitiesForLenderFilter(searchText) {
            if (!vm.lenderFilterRegion || !vm.lenderFilterRegion.id) {
                return $q.when([]);
            }
            return $http.get('api/cities', {
                params: {
                    regionId: vm.lenderFilterRegion.id,
                    query: searchText || '',
                    size: 100,
                    page: 0,
                    sort: 'name,asc'
                }
            }).then(function(response) {
                return response.data || [];
            });
        }

        function onLenderFilterRegionSelected(region) {
            vm.lenderFilterRegion = region;
            vm.lenderFilterCity = null;
            vm.lenderFilterCitySearch = '';
        }

        function onLenderFilterCitySelected(city) {
            vm.lenderFilterCity = city;
        }

        function pruneTopLenderSelection() {
            var allowed = {};
            angular.forEach(vm.lenderDrilldownOptions, function(opt) {
                allowed[opt.lenderId] = true;
            });
            vm.selectedLenderIds = (vm.selectedLenderIds || []).filter(function(id) {
                return allowed[id];
            });
        }

        function loadTimeSeriesOnly() {
            if (vm.lenderFilterCity && vm.lenderFilterCity.id && (!vm.lenderFilterRegion || !vm.lenderFilterRegion.id)) {
                AlertService.error(translate('valueconnectApp.report.pendingAssignmentRate.lenderFilterRegionRequired'));
                return;
            }
            vm.chartLoading = true;
            var scoped = chartAndOrdersParams();
            var tsParams = angular.extend({ granularity: vm.granularity }, scoped);
            $http.get('api/reports/pending-assignment-rate-timeseries', { params: tsParams })
                .then(function(response) {
                    vm.series = response.data;
                    vm.chartLoading = false;
                    $timeout(function() {
                        renderChart(vm.series);
                    });
                })
                .catch(function(err) {
                    vm.chartLoading = false;
                    var hdr = err.headers && err.headers('X-valueconnectApp-error');
                    var msg = (err.data && err.data.message) || hdr || err.statusText || 'Request failed';
                    AlertService.error(msg);
                });
        }

        function load() {
            if (vm.lenderFilterCity && vm.lenderFilterCity.id && (!vm.lenderFilterRegion || !vm.lenderFilterRegion.id)) {
                AlertService.error(translate('valueconnectApp.report.pendingAssignmentRate.lenderFilterRegionRequired'));
                return;
            }
            var regionCityKey = getRegionCityBreakdownKey();
            var lenderTableKey = getLenderOptionsKey();
            var optionsKey = getLenderOptionsKey();
            var needRegionCity = (vm._lastRegionCityBreakdownKey !== regionCityKey);
            var needLenderTable = (vm._lastLenderBreakdownTableKey !== lenderTableKey);
            var sameOptions = (vm._lastLenderOptionsKey === optionsKey);
            var needFullBreakdownBlock = needRegionCity && needLenderTable;

            vm.tableLoading = true;
            if (needFullBreakdownBlock) {
                vm.loading = true;
                vm.chartLoading = false;
                vm.regionTableLoading = true;
                vm.cityTableLoading = true;
                vm.lenderTableLoading = true;
            } else {
                vm.loading = false;
                vm.chartLoading = true;
                vm.regionTableLoading = needRegionCity;
                vm.cityTableLoading = needRegionCity;
                vm.lenderTableLoading = needLenderTable;
            }
            if (needRegionCity) {
                vm.regionPage = 1;
                vm.cityPage = 1;
            }
            if (needLenderTable) {
                vm.lenderPage = 1;
            }
            if (!sameOptions) {
                vm.lenderOptionsLoading = true;
            }

            vm.ordersPage = 1;
            var scoped = chartAndOrdersParams();
            var tsParams = angular.extend({ granularity: vm.granularity }, scoped);
            var qParams = angular.extend({
                page: vm.ordersPage - 1,
                size: vm.itemsPerPage
            }, scoped);
            var regionParams = regionBreakdownParams(vm.regionPage);
            var cityParams = cityBreakdownParams(vm.cityPage);
            var lenderParams = lenderBreakdownParams(vm.lenderPage);
            var lenderOptsParams = lenderOptionsRequestParams();

            var requests = [
                $http.get('api/reports/pending-assignment-rate-timeseries', { params: tsParams }),
                $http.get('api/reports/pending-assignment-rate-orders', { params: qParams })
            ];
            if (needRegionCity) {
                requests.push($http.get('api/reports/pending-assignment-rate-by-region', { params: regionParams }));
                requests.push($http.get('api/reports/pending-assignment-rate-by-city', { params: cityParams }));
            }
            if (needLenderTable) {
                requests.push($http.get('api/reports/pending-assignment-rate-by-lender', { params: lenderParams }));
            }
            if (!sameOptions) {
                requests.push($http.get('api/reports/pending-assignment-rate-lender-options', { params: lenderOptsParams }));
            }

            $q.all(requests)
                .then(function(results) {
                    var i = 0;
                    vm.series = results[i++].data;
                    applyOrdersResponse(results[i++].data);
                    if (needRegionCity) {
                        applyRegionPageResponse(results[i++].data);
                        applyCityPageResponse(results[i++].data);
                    }
                    if (needLenderTable) {
                        applyLenderPageResponse(results[i++].data);
                    }
                    if (!sameOptions) {
                        vm.lenderDrilldownOptions = results[i++].data || [];
                        pruneTopLenderSelection();
                    }
                    vm._lastRegionCityBreakdownKey = regionCityKey;
                    vm._lastLenderBreakdownTableKey = lenderTableKey;
                    vm._lastLenderOptionsKey = optionsKey;
                    vm.loading = false;
                    vm.tableLoading = false;
                    vm.chartLoading = false;
                    vm.regionTableLoading = false;
                    vm.cityTableLoading = false;
                    vm.lenderTableLoading = false;
                    vm.lenderOptionsLoading = false;
                    $timeout(function() {
                        renderChart(vm.series);
                    });
                })
                .catch(function(err) {
                    vm.loading = false;
                    vm.tableLoading = false;
                    vm.chartLoading = false;
                    vm.regionTableLoading = false;
                    vm.cityTableLoading = false;
                    vm.lenderTableLoading = false;
                    vm.lenderOptionsLoading = false;
                    var hdr = err.headers && err.headers('X-valueconnectApp-error');
                    var msg = (err.data && err.data.message) || hdr || err.statusText || 'Request failed';
                    AlertService.error(msg);
                });
        }

        function onOrdersPageChange() {
            vm.tableLoading = true;
            $http.get('api/reports/pending-assignment-rate-orders', {
                params: angular.extend({
                    page: vm.ordersPage - 1,
                    size: vm.itemsPerPage
                }, chartAndOrdersParams())
            }).then(function(response) {
                applyOrdersResponse(response.data);
                vm.tableLoading = false;
            }).catch(function(err) {
                vm.tableLoading = false;
                var hdr = err.headers && err.headers('X-valueconnectApp-error');
                var msg = (err.data && err.data.message) || hdr || err.statusText || 'Request failed';
                AlertService.error(msg);
            });
        }

        function onRegionPageChange() {
            vm.regionTableLoading = true;
            $http.get('api/reports/pending-assignment-rate-by-region', {
                params: regionBreakdownParams(vm.regionPage)
            }).then(function(response) {
                applyRegionPageResponse(response.data);
                vm.regionTableLoading = false;
            }).catch(function(err) {
                vm.regionTableLoading = false;
                var hdr = err.headers && err.headers('X-valueconnectApp-error');
                var msg = (err.data && err.data.message) || hdr || err.statusText || 'Request failed';
                AlertService.error(msg);
            });
        }

        function onCityPageChange() {
            vm.cityTableLoading = true;
            $http.get('api/reports/pending-assignment-rate-by-city', {
                params: cityBreakdownParams(vm.cityPage)
            }).then(function(response) {
                applyCityPageResponse(response.data);
                vm.cityTableLoading = false;
            }).catch(function(err) {
                vm.cityTableLoading = false;
                var hdr = err.headers && err.headers('X-valueconnectApp-error');
                var msg = (err.data && err.data.message) || hdr || err.statusText || 'Request failed';
                AlertService.error(msg);
            });
        }

        function onRegionSortCallback() {
            vm.regionPage = 1;
            onRegionPageChange();
        }

        function onCitySortCallback() {
            vm.cityPage = 1;
            onCityPageChange();
        }

        function onLenderPageChange() {
            vm.lenderTableLoading = true;
            $http.get('api/reports/pending-assignment-rate-by-lender', {
                params: lenderBreakdownParams(vm.lenderPage)
            }).then(function(response) {
                applyLenderPageResponse(response.data);
                vm.lenderTableLoading = false;
            }).catch(function(err) {
                vm.lenderTableLoading = false;
                var hdr = err.headers && err.headers('X-valueconnectApp-error');
                var msg = (err.data && err.data.message) || hdr || err.statusText || 'Request failed';
                AlertService.error(msg);
            });
        }

        function onLenderSortCallback() {
            vm.lenderPage = 1;
            onLenderPageChange();
        }

        function applyRegionPageResponse(data) {
            vm.regionRows = (data && data.content) ? data.content : [];
            vm.regionTotalElements = data && data.totalElements != null ? data.totalElements : 0;
        }

        function applyCityPageResponse(data) {
            vm.cityRows = (data && data.content) ? data.content : [];
            vm.cityTotalElements = data && data.totalElements != null ? data.totalElements : 0;
        }

        function applyLenderPageResponse(data) {
            vm.lenderRows = (data && data.content) ? data.content : [];
            vm.lenderTotalElements = data && data.totalElements != null ? data.totalElements : 0;
        }

        function openOrderInNewTab(orderId) {
            var url = $state.href('appraisal-order-detail', { id: orderId }, { absolute: true });
            $window.open(url, '_blank', 'noopener,noreferrer');
        }

        function applyOrdersResponse(data) {
            vm.summary = data.summary || null;
            var page = data.pendingAssignmentEntries;
            vm.orders = (page && page.content) ? page.content : [];
            vm.ordersTotalElements = page && page.totalElements != null ? page.totalElements : 0;
        }

        function formatLabel(periodStart, granularity) {
            var m = moment(periodStart);
            if (granularity === 'MONTHLY') {
                return m.format('MMM YYYY');
            }
            return m.format('MMM D, YYYY');
        }

        function weekBoundsFromMonday(periodStart) {
            var monday = moment(periodStart).startOf('day');
            var sunday = monday.clone().add(6, 'days');
            return { monday: monday, sunday: sunday };
        }

        function formatWeekAxisLabel(periodStart) {
            var w = weekBoundsFromMonday(periodStart);
            return w.monday.format('MMM D') + ' – ' + w.sunday.format('MMM D, YYYY');
        }

        function renderChart(data) {
            var canvas = document.getElementById('pending-assignment-rate-chart');
            if (!canvas || typeof Chart === 'undefined') {
                return;
            }
            var ctx = canvas.getContext('2d');
            destroyChart();

            var labels = (data.points || []).map(function(p) {
                if (data.granularity === 'WEEKLY') {
                    return formatWeekAxisLabel(p.periodStart);
                }
                return formatLabel(p.periodStart, data.granularity);
            });
            var values = (data.points || []).map(function(p) {
                return Number(p.entries || 0);
            });

            var tooltipCallbacks = {
                title: function(tooltipItems) {
                    if (!tooltipItems || !tooltipItems.length) {
                        return '';
                    }
                    var pts = data.points || [];
                    var p = pts[tooltipItems[0].index];
                    if (!p) {
                        return '';
                    }
                    if (data.granularity === 'WEEKLY') {
                        var wk = weekBoundsFromMonday(p.periodStart);
                        return translate('valueconnectApp.report.pendingAssignmentRate.weeklyTooltipTitle', {
                            start: wk.monday.format('MMM D, YYYY'),
                            end: wk.sunday.format('MMM D, YYYY')
                        });
                    }
                    if (data.granularity === 'MONTHLY') {
                        return moment(p.periodStart).format('MMMM YYYY');
                    }
                    return formatLabel(p.periodStart, data.granularity);
                },
                label: function(tooltipItem) {
                    var pts = data.points || [];
                    var p = pts[tooltipItem.index];
                    if (!p) {
                        return '';
                    }
                    return [
                        translate('valueconnectApp.report.pendingAssignmentRate.tooltipEntries', { count: p.entries }),
                        translate('valueconnectApp.report.pendingAssignmentRate.tooltipDistinctOrders', { count: p.distinctOrders })
                    ];
                }
            };
            if (data.granularity === 'WEEKLY') {
                tooltipCallbacks.footer = function() {
                    return translate('valueconnectApp.report.pendingAssignmentRate.weeklyTooltipFooter');
                };
            }

            vm.chart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: translate('valueconnectApp.report.pendingAssignmentRate.chartAxisLabel'),
                        data: values,
                        borderColor: 'rgb(41, 128, 185)',
                        backgroundColor: 'rgba(41, 128, 185, 0.15)',
                        pointBackgroundColor: 'rgb(41, 128, 185)',
                        pointBorderColor: '#fff',
                        pointBorderWidth: 2,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                        lineTension: 0.2,
                        spanGaps: false
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                // Entry counts are whole numbers; hide the fractional ticks Chart.js
                                // interpolates on small ranges.
                                callback: function(value) {
                                    return (value % 1 === 0) ? value : undefined;
                                }
                            },
                            scaleLabel: {
                                display: true
                            }
                        }],
                        xAxes: [{
                            gridLines: { display: false }
                        }]
                    },
                    tooltips: {
                        callbacks: tooltipCallbacks
                    }
                }
            });
        }
    }
})();
